import React from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatedSelect } from '@cp-shared-19/frontend-ui';

type CountrySelectionProps = {
    name: string;
    label: string;
    selectId?: string;
};

export const CountrySelection: React.FC<CountrySelectionProps> = ({ name, label, selectId }) => {
    const { t } = useTranslation('request');
    const translationPrefix = 'category-selection.country-selection';
    const translate = (key: string): string => {
        return t(`${translationPrefix}.${key}`);
    };

    const countries: string[] = [
        'Maroc',
        'Tunisie',
        'Turquie',
        'Grande Bretagne',
        'Irlande du nord',
        'Roumanie',
        'Albanie',
        'Bosnie-Herzégovine',
        'Chypre',
        'Monténégro',
        'Macédoine du Nord',
        'Serbie',
        'Kosovo',
        'Croatie',
        'Bulgarie',
    ];

    return (
        <>
            <ValidatedSelect
                className="c-form-field--no-floating"
                isMandatory={true}
                required={true}
                requiredText=" *"
                name={name}
                id={selectId}
                selectItems={countries.map((country) => ({
                    value: country,
                    label: country,
                }))}
                placeholder={translate('placeholder')}
                label={label}
                emptyByDefault
                autocomplete="country"
            />
        </>
    );
};
